import { useAtomValue } from "jotai";
import { useResolvingNowQuery } from "web_myplann/Api/NotificationCenter/useResolvingNowQuery";
import { useUpcomingTimelineQuery } from "web_myplann/Api/NotificationCenter/useUpcomingTimelineQuery";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { useGroupUpcomingItems } from "web_myplann/NotificationCenter/Hooks/useGroupUpcomingItems";

export const useUpcomingTimelineGroups = (options?: { enabled?: boolean }) => {
	const { horizon, upcomingType } = useAtomValue(timelineFilterAtom);
	const upcomingQuery = useUpcomingTimelineQuery(
		{ horizon, type: upcomingType },
		options,
	);
	const resolvingNowQuery = useResolvingNowQuery(
		{ type: upcomingType },
		options,
	);
	const timeGroups = useGroupUpcomingItems(
		upcomingQuery.data?.items ?? [],
		horizon,
	);

	return {
		upcomingQuery,
		resolvingNowQuery,
		resolvingNow: resolvingNowQuery.data?.items ?? [],
		timeGroups,
	};
};
